import * as React from "react";
import { SessionTypes } from "../../misc/api/ApiSessionTypes";
import { useWebPortalApiClient } from "../../misc/api/WebPortalTokenClient";
import Alert, { AlertCategoryEnum } from "../../misc/components/Alert";

export interface ChallengeAlertProps {
    sessionId: string;
    sessionType: SessionTypes;
    onRejectComplete: () => void;
}

export const ChallengeAlert = ({ sessionId, sessionType, onRejectComplete }: ChallengeAlertProps) => {
    const client = useWebPortalApiClient();

    const handleRejectChallenge = () => {
        switch (sessionType) {
            case SessionTypes.Fvc:
                client.client.patchFvcSession({ challengeIsClosed: true }, sessionId).then(() => onRejectComplete());
                break;
            case SessionTypes.Svc:
                client.client.patchSvcSession({ challengeIsClosed: true }, sessionId).then(() => onRejectComplete());
                break;
            case SessionTypes.Mip:
                client.client.patchMipSession({ challengeIsClosed: true }, sessionId).then(() => onRejectComplete());
                break;
            case SessionTypes.Mep:
                client.client.patchMepSession({ challengeIsClosed: true }, sessionId).then(() => onRejectComplete());
                break;
            case SessionTypes.Snip:
                client.client.patchSnipSession({ challengeIsClosed: true }, sessionId).then(() => onRejectComplete());
                break;
            case SessionTypes.Dlco:
                client.client.patchDlcoSession({ challengeIsClosed: true }, sessionId).then(() => onRejectComplete());
                break;
            case SessionTypes.LungVolumeHelium:
                client.client.patchLungVolumeSession({ challengeIsClosed: true }, sessionId).then(() => onRejectComplete());
                break;
            case SessionTypes.LungVolumePleth:
                client.client.patchLungVolumeSession({ challengeIsClosed: true }, sessionId).then(() => onRejectComplete());
                break;
        }
    }

    return (
        <Alert show={true} category={AlertCategoryEnum.Warning}>
            The technician has challenged the over-reading decision, please review the session. <a style={{ cursor: 'pointer' }} onClick={handleRejectChallenge}>Reject challenge</a>
        </Alert>
    );
}
